function getMothersDay(year) {
  const mayFirst = new Date(year, 4, 1);
  const day = mayFirst.getDay();
  const firstSundayOffset = (7 - day) % 7;
  const firstSunday = 1 + firstSundayOffset;
  return new Date(year, 4, firstSunday + 7);
}

const dynamicEvents = [
  {
    id: "mothers-day",
    dynamic: true,
    getDate: (year) => getMothersDay(year),
    category: "international",
    title: "Mother's Day",
    description: `Mother’s Day is celebrated to honor and appreciate mothers 
    and maternal figures for their unconditional love, sacrifice, and guidance. 
    It is a time to express gratitude and celebrate family bonds.`,
    color: "#AD1457"
  }
];

export default dynamicEvents;